export default __webpack_public_path__ + "static/media/7.ab88bf29.jpg";